import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioKnowledgeRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio-knowledge',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/knowledge',
	exact: true,
};
